import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;

// TODO: switch to "PRODUCTION" and set a real Google Pay merchant ID
// (from the Google Pay & Wallet Console) before going live.
const GOOGLE_PAY_ENVIRONMENT = "TEST";
const GOOGLE_MERCHANT_ID = "sanborns-google-pay-merchant-id";

export function getGooglePayTokenClient(data, issuePolicy, clientToken) {
  braintree.client.create(
    {
      authorization: clientToken,
    },
    function (clientErr, clientInstance) {
      if (clientErr) {
        alert("Error creating client:");
        return;
      }

      let deviceData;

      braintree.dataCollector.create(
        {
          client: clientInstance,
        },
        function (dataCollectorErr, dataCollectorInstance) {
          if (dataCollectorErr) {
            console.error("Error creating dataCollectorInstance:", dataCollectorErr);
            return;
          }
          deviceData = dataCollectorInstance.deviceData;
        }
      );

      braintree.googlePayment.create(
        {
          client: clientInstance,
          googlePayVersion: 2,
          googleMerchantId: GOOGLE_MERCHANT_ID,
        },
        function (googlePayErr, googlePaymentInstance) {
          if (googlePayErr) {
            alert("Error creating googlePaymentInstance:");
            return;
          }

          var paymentsClient = new google.payments.api.PaymentsClient({
            environment: GOOGLE_PAY_ENVIRONMENT,
          });

          var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
            transactionInfo: {
              currencyCode: "USD",
              totalPriceStatus: "FINAL",
              totalPrice: `${data.coverages.total}`,
            },
          });

          paymentsClient
            .isReadyToPay({
              apiVersion: paymentDataRequest.apiVersion,
              apiVersionMinor: paymentDataRequest.apiVersionMinor,
              allowedPaymentMethods: paymentDataRequest.allowedPaymentMethods,
            })
            .then(function (response) {
              if (!response.result) {
                alert("Google Pay is not available on this device.");
                return;
              }

              paymentsClient
                .loadPaymentData(paymentDataRequest)
                .then(function (paymentData) {
                  googlePaymentInstance.parseResponse(
                    paymentData,
                    function (tokenizeErr, payload) {
                      if (tokenizeErr) {
                        alert("Error tokenizing Google Pay:");
                        return;
                      }

                      payload.deviceData = deviceData;

                      issuePolicy(payload);
                    }
                  );
                })
                .catch(function (err) {
                  console.error("Google Pay payment cancelled or failed:", err);
                });
            });
        }
      );
    }
  );
}
